import { forwardRef } from 'react';

import Link from '@mui/material/Link';
import Box, { BoxProps } from '@mui/material/Box';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { useSettingsContext } from '../settings';

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, sx, ...other }, ref) => {
    const settings = useSettingsContext();

    const logo =
      settings.themeLayout !== 'mini' ? (
        <Box
          ref={ref}
          component="div"
          sx={{
            width: 40,
            height: 'auto',
            display: 'inline-flex',
            position: 'relative',
            ...sx,
          }}
          {...other}
        >
          <img src="/logo.jpg" alt="Lyst IT" style={{ objectFit: 'contain' }} />
        </Box>
      ) : (
        <Box
          ref={ref}
          component="div"
          sx={{
            width: 'auto',
            height: 40,
            display: 'inline-flex',
            ...sx,
          }}
          {...other}
        >
          <img src="/logo.jpg" alt="Lyst IT" style={{ objectFit: 'contain' }} />
        </Box>
      );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link component={RouterLink} href={paths.dashboard.root} sx={{ display: 'contents' }}>
        {logo}
      </Link>
    );
  }
);

export default Logo;
